<template>
    <div class="navigation mobile wrapping">
        <button class="navigation hamburger"
                aria-controls="navigation"
                :aria-expanded="opened"
                @click="toggle">
            <svg class="hamburger" viewBox="0 0 100 100" width="100%">
                <rect class="line top"
                      width="80"
                      height="10"
                      x="10"
                      y="25"
                      rx="5"></rect>
                <rect class="line middle"
                      width="80"
                      height="10"
                      x="10"
                      y="45"
                      rx="5"></rect>
                <rect class="line bottom"
                      width="80"
                      height="10"
                      x="10"
                      y="65"
                      rx="5"></rect>
            </svg>
        </button>
    </div>
    <transition appear name="next">
        <div class="mobile-navigation" v-if="opened">
            <template v-for="( nav, index ) in navigation[$store.getters.authorized]" :key="'nav-'+index">
                <a v-if="!nav.level || nav.level <= $store.getters.level"
                   :class="'item'+( nav.name === $route.name ? ' active' : '' )" @click="navigate( $event, index )">
                    {{ nav.label }}
                </a>
            </template>
        </div>
    </transition>
</template>

<script>
export default {
    
    name: 'Hamburger',
    emits: ['navigate'],
    props: {
        navigation: { type: Object, required: true },
    },
    data()
    {
        return {
            opened: false
        }
    },
    
    methods: {
        toggle()
        {
            
            this.opened = !this.opened
            
        },
        navigate( event, index )
        {
            this.opened = false
            this.$emit( 'navigate', { event: event, index: index } );
        }
    }
    
}
</script>